// extracted by mini-css-extract-plugin
export default {"root":"lQ60nhOA","textContainer":"mmluzV4w"};